import React from "react";
import { useTranslation } from "react-i18next";
import { CircleCheckIcon } from "lucide-react";
import CustomSelect from "../../custom/custom-select/CustomSelect";
import { getLegalTypeOptions } from "../legalTypes";
import style from "./index.module.scss";

const SelectLegalType = ({ selectedLegalType, setSelectedLegalType }) => {
  const { t } = useTranslation();
  const options = getLegalTypeOptions(t);
  const selectedOption = options.find((option) => option.value === selectedLegalType) || null;

  const handleSelect = (value) => {
    if (!value || value === selectedLegalType) return;
    setSelectedLegalType(value);
  };

  return (
    <section className={style.card}>
      <div className={style.cardHead}>
        <div className={style.cardTitleRow}>
          <CircleCheckIcon aria-hidden="true" size={24} strokeWidth={1.5} />
          <h2 className={style.cardTitle}>{t("selectLegalTypeComponent.card.title")}</h2>
        </div>
        <p className={style.cardText}>{t("selectLegalTypeComponent.card.text")}</p>
      </div>

      <div className={style.selectField}>
        <CustomSelect
          options={options}
          defaultValue={selectedOption}
          keyId="value"
          keyName="label"
          labelText={t("selectLegalTypeComponent.fieldLabel")}
          placeholder={t("selectLegalTypeComponent.placeholder")}
          onSubmit={handleSelect}
          bgWhite
        />
      </div>
    </section>
  );
};

export default SelectLegalType;
